/**
 * Defers loading + playback of slideshow hero videos until the visitor first
 * scrolls or interacts with the page.
 *
 * Until then the poster image (rendered alongside the <video> and preloaded as
 * the LCP) stands in, so the hero paints instantly and no video bytes download
 * on initial load. This trims network contention and main-thread work during
 * the critical first-paint window without changing what the visitor sees.
 *
 * Markup contract: a `<video data-defer-load='true' preload='none'>` with no
 * `autoplay` attribute. On the first scroll/interaction we flip `preload`, call
 * `load()`, then `play()` (videos are muted, so autoplay-on-play is allowed).
 */
(function () {
  if (window.__deferVideoInit) return;
  window.__deferVideoInit = true;

  var triggered = false;

  function playVideo(video) {
    var promise = video.play();
    if (promise && typeof promise.catch === 'function') {
      // Autoplay can still be blocked (e.g. data-saver); fail silently and
      // leave the poster in place.
      promise.catch(function () {});
    }
  }

  function loadDeferredVideos() {
    var videos = document.querySelectorAll('video[data-defer-load]');

    for (var i = 0; i < videos.length; i++) {
      var video = videos[i];
      if (video.dataset.deferLoaded) continue;
      video.dataset.deferLoaded = 'true';

      // A <video> with only `<source media>` entries that don't match (mobile)
      // has no current source — `load()`/`play()` are harmless no-ops there.
      video.preload = 'auto';
      video.load();

      if (video.readyState >= 2 /* HAVE_CURRENT_DATA */) {
        playVideo(video);
      } else {
        video.addEventListener(
          'canplay',
          (function (el) {
            return function () {
              playVideo(el);
            };
          })(video),
          { once: true }
        );
      }
    }
  }

  function onTrigger() {
    if (triggered) return;
    triggered = true;
    loadDeferredVideos();
  }

  function init() {
    if (!document.querySelector('video[data-defer-load]')) return;

    var options = { passive: true, once: true };
    window.addEventListener('scroll', onTrigger, options);
    window.addEventListener('wheel', onTrigger, options);
    window.addEventListener('touchstart', onTrigger, options);
    window.addEventListener('pointerdown', onTrigger, options);
    window.addEventListener('keydown', onTrigger, { once: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
